<template>
  <div v-loading.sync.fullscreen="loading">
    <div>
      <el-form ref="search-form" :model="query" label-width="80px" inline size="small">
        <el-form-item class="label-inline" label="关键词" prop="keyword"
                      :rules="[{required: true, message: '查询关键词不能为空。'}, {min: 2, message: '查询关键词不能少于2个字'}]">
          <el-input v-model="query.keyword" placeholder="输入查询的标题" class="inline-input"></el-input>
        </el-form-item>
        <el-form-item class="label-inline" label="时间" prop="time">
          <el-select v-model="query.timeType" class="inline-input">
            <el-option label="当天" value="1"></el-option>
            <el-option label="两天内" value="2"></el-option>
            <el-option label="三天内" value="3"></el-option>
            <el-option label="四天内" value="4"></el-option>
            <el-option label="五天内" value="5"></el-option>
            <el-option label="六天内" value="6"></el-option>
            <el-option label="七天内" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="text-center" label=" ">
          <el-button icon="el-icon-search" type="primary" size="small" @click="doSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-pagination v-if="searched" small :total="page.totalElements" :page-size="page.size"
                     layout="prev, pager, next, ->, total" :current-page.sync="page.number"
                     :page-count="page.totalPages" @current-change="doSearch"></el-pagination>
    </div>
    <div>
      <div v-for="(item, idx) in items" :key="item.url" style="margin: 8px 0">
        <daily-report-item-card :item="item" :index="idx + 1"
                                :highlight-titles="heighlights"></daily-report-item-card>
      </div>
    </div>
  </div>
</template>

<script>

import DailyReportItemCard from "@/components/daily/DailyReportItemCard";
import Page from "@/models/Page";
import SearchService from "@/services/searchService/SearchService";
import DailyReportItem from "@/models/DailyReportItem";

export default {
  name: "KeyWordSearchComponent",
  components: {DailyReportItemCard},
  data() {
    return {
      page: new Page(),
      searched: false,
      loading: false,
      items: [],
      query: {}
    }
  },
  computed:{
    heighlights() {
      return this.query.keyword.split(/[, ]/g)
    }
  },
  methods: {
    doSearch() {
      this.$refs['search-form'].validate(valid => {
        if (valid) {
          this.loading = true
          this.searched = true
          SearchService.searchByKeyWord(this.query.keyword, this.query.timeType, this.page.asQueryPage())
              .then(resp => {
            if (resp.status === 200 && resp.data) {
              this.page = Page.MapPageByResp(resp.data)
              this.items = (resp.data.content || []).map(i => new DailyReportItem(i))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
